import { call, put, select } from 'redux-saga/effects';

import request from '../request';
import selectors from '../../../selectors';
import actions from '../../../actions';
import api from '../../../api';
import orm from '../../../orm';

export function* getOrCreateDampingCoefficientInCurrentBoard() {
  const pointSystem = yield select(selectors.selectPointSystemForSettingsModal);
  if (!pointSystem) {
    return;
  }

  yield put(actions.getOrCreateDampingCoefficient(pointSystem.id));

  let item;
  try {
    ({ item } = yield call(request, api.getOrCreateDampingCoefficient, pointSystem.id));
  } catch (error) {
    yield put(actions.getOrCreateDampingCoefficient.failure(pointSystem.id, error));
    return;
  }

  yield put(actions.getOrCreateDampingCoefficient.success(item));
}

export function* fetchDampingCoefficientsInCurrentBoard(pointSystemIdParam = null) {
  console.log('[fetchDampingCoefficientsInCurrentBoard] Начало функции, pointSystemIdParam:', pointSystemIdParam);
  
  let pointSystemId = pointSystemIdParam;
  
  // Если pointSystemId не передан, пытаемся найти через селектор
  if (!pointSystemId) {
    const pointSystem = yield select(selectors.selectPointSystemForSettingsModal);
    console.log('[fetchDampingCoefficientsInCurrentBoard] pointSystem из селектора:', pointSystem);
    console.log('[fetchDampingCoefficientsInCurrentBoard] pointSystem?.id:', pointSystem?.id);
    if (!pointSystem) {
      console.log('[fetchDampingCoefficientsInCurrentBoard] pointSystem не найден через селектор, выходим');
      return;
    }
    pointSystemId = pointSystem.id;
  }

  console.log('[fetchDampingCoefficientsInCurrentBoard] Запрашиваем DampingCoefficients для pointSystemId:', pointSystemId);
  console.log('[fetchDampingCoefficientsInCurrentBoard] Диспатчим action DAMPING_COEFFICIENTS_FETCH');
  yield put(actions.fetchDampingCoefficients(pointSystemId));
  console.log('[fetchDampingCoefficientsInCurrentBoard] Action DAMPING_COEFFICIENTS_FETCH отправлен');

  let items;
  try {
    console.log('[fetchDampingCoefficientsInCurrentBoard] Вызываем API fetchDampingCoefficients');
    ({ items } = yield call(request, api.fetchDampingCoefficients, pointSystemId));
    console.log('[fetchDampingCoefficientsInCurrentBoard] Получены DampingCoefficients с сервера:', items);
    console.log('[fetchDampingCoefficientsInCurrentBoard] Количество items:', items?.length || 0);
    if (items && items.length > 0) {
      console.log('[fetchDampingCoefficientsInCurrentBoard] Первый item:', items[0]);
      console.log('[fetchDampingCoefficientsInCurrentBoard] Первый item поля:', Object.keys(items[0]));
    }
  } catch (error) {
    console.error('[fetchDampingCoefficientsInCurrentBoard] Ошибка при загрузке:', error);
    console.error('[fetchDampingCoefficientsInCurrentBoard] Ошибка детали:', error.message, error.stack);
    yield put(actions.fetchDampingCoefficients.failure(pointSystemId, error));
    return;
  }

  console.log('[fetchDampingCoefficientsInCurrentBoard] Сохраняем DampingCoefficients в Redux:', items);
  console.log('[fetchDampingCoefficientsInCurrentBoard] Диспатчим action DAMPING_COEFFICIENTS_FETCH__SUCCESS с pointSystemId:', pointSystemId, 'items:', items);
  yield put(actions.fetchDampingCoefficients.success(pointSystemId, items));
  console.log('[fetchDampingCoefficientsInCurrentBoard] Action DAMPING_COEFFICIENTS_FETCH__SUCCESS отправлен');
  console.log('[fetchDampingCoefficientsInCurrentBoard] DampingCoefficients сохранены в Redux');
  
  // Проверяем, что данные действительно сохранились
  const state = yield select();
  const session = orm.session(state.orm);
  const dampingCoefficientsInOrm = session.DampingCoefficient.all()
    .filter({ pointSistemId: pointSystemId })
    .toRefArray();
  console.log('[fetchDampingCoefficientsInCurrentBoard] Проверка после сохранения, количество в ORM:', dampingCoefficientsInOrm.length);
  console.log('[fetchDampingCoefficientsInCurrentBoard] Проверка после сохранения, данные в ORM:', dampingCoefficientsInOrm);
}

export function* createDampingCoefficient(pointSystemId, data = {}) {
  yield put(actions.createDampingCoefficient(pointSystemId));

  let item;
  try {
    ({ item } = yield call(request, api.createDampingCoefficient, pointSystemId, data));
  } catch (error) {
    yield put(actions.createDampingCoefficient.failure(pointSystemId, error));
    return;
  }

  yield put(actions.createDampingCoefficient.success(item));
}

export function* updateDampingCoefficient(id, data) {
  yield put(actions.updateDampingCoefficient(id, data));

  let item;
  try {
    ({ item } = yield call(request, api.updateDampingCoefficient, id, data));
  } catch (error) {
    yield put(actions.updateDampingCoefficient.failure(id, error));
    return;
  }

  yield put(actions.updateDampingCoefficient.success(item));
}

export function* deleteDampingCoefficient(id) {
  yield put(actions.deleteDampingCoefficient(id));

  let item;
  try {
    ({ item } = yield call(request, api.deleteDampingCoefficient, id));
  } catch (error) {
    yield put(actions.deleteDampingCoefficient.failure(id, error));
    return;
  }

  yield put(actions.deleteDampingCoefficient.success(item));
}

export default {
  getOrCreateDampingCoefficientInCurrentBoard,
  fetchDampingCoefficientsInCurrentBoard,
  createDampingCoefficient,
  updateDampingCoefficient,
  deleteDampingCoefficient,
};

